import type { Settings } from "../types/settings"
import { FlowType } from "conversion_flows/types/scalars"

export type FlowAvailabilityStatus = "available" | "unavailable"

export const getFlowStatus = (settings: Settings): Record<FlowType, FlowAvailabilityStatus> => {
  return Object.entries(settings.flowAvailability).reduce(
    (acc, [flowType, isAvailable]) => ({
      ...acc,
      [flowType]: isAvailable ? "available" : "unavailable"
    }),
    {} as Record<FlowType, FlowAvailabilityStatus>
  )
}
